// pc
    function customVideoPlay(element){
        var video = $(element).find('.custom-autoPlay-videoPlayer')[0];
        if (!video) return;
        if (typeof window.lazyLoadElement === 'function' && video.querySelector('source[data-src]')) {
            window.lazyLoadElement(video);
        }
        videoPlayOrPause(video,"customVideoPlayButton");
    }

    function videoPlayMobile(element){
        var video = $(element).find('.custom-autoPlay-videoPlayer-mobile')[0];
        if (!video) return;
        if (typeof window.lazyLoadElement === 'function' && video.querySelector('source[data-src]')) {
            window.lazyLoadElement(video);
        }
        videoPlayOrPause(video,"customVideoPlayButtonMobile");
    }

    function videoPlayOrPause(video,buttonId){
    var videoButton = $("#"+buttonId);

    if (video.paused){
        videoButton.fadeOut();
        video.play();
        video.controls = true;
    }else {
        videoButton.fadeIn();
        video.pause();
        video.controls = false;
    }
}